export enum AvailableOperationTypes {
    ACEP = 'ACEP', // Firma simple
    RVDOTP = 'RVDOTP', // Firma avanzada SMS
    SIGBIO = 'SIGBIO', // Firma avanzada biométrica
    SIG = 'SIG', // Firma con certificado
    DWN = 'DWN', // Envío certificado
    SIGQSCD = 'SIGQSCD', // Firma con certificado QSCD
    DYNSIG = 'DYNSIG', // Firma dinámica
    VAL = 'VAL', // Validación
    STOP = 'STOP', // Suspensión del circuito
    NOTI = 'NOTI', // Notification
    NOTE = 'NOTE', // Notificación electrónica
    QERDS = 'QERDS', // Notificación electrónica cualificada
    SIGORGA = 'SIGORGA' // Firma automática de empresa
}
